import { useLogger, useUniversalFetch, useUniversalPut } from "#imports";
async function isFeatureEnabled(featureFlagId) {
  const endpoint = `/api/feature-flipping/${featureFlagId}`;
  let enabled = false;
  try {
    enabled = await useUniversalFetch(endpoint);
  } catch {
  }
  return enabled;
}
async function isFeatureEnabledForHost(featureFlagId) {
  const endpoint = `/api/feature-flipping/host/${featureFlagId}`;
  let enabled = false;
  try {
    enabled = await useUniversalFetch(endpoint);
  } catch {
  }
  return enabled;
}
export class FeatureFlag {
  feature;
  isEnabledForUser;
  isCanBeModifiedForUser;
  constructor(feature, isEnabledForUser, isCanBeModifiedForUser) {
    this.feature = feature;
    this.isEnabledForUser = isEnabledForUser;
    this.isCanBeModifiedForUser = isCanBeModifiedForUser;
  }
}
async function fetchFeatureFlags(featureFlagIds = []) {
  if (featureFlagIds.length === 0) {
    return {};
  }
  const ffList = featureFlagIds.join(",");
  const endpoint = `/api/feature-flipping/fetch/${ffList}`;
  let ffStates = featureFlagIds.reduce((states, flagId) => {
    states[flagId] = false;
    return states;
  }, {});
  try {
    ffStates = await useUniversalFetch(endpoint);
  } catch {
  }
  return ffStates;
}
async function switchStateFeatureFlag(featureFlagId, isEnabled) {
  const logger = useLogger();
  const endpoint = `/api/feature-flipping/${featureFlagId}/state`;
  const enabled = false;
  try {
    await useUniversalPut(endpoint, {
      query: { enabled: isEnabled }
    });
  } catch {
    logger.error(`Error while changing status of FF "${featureFlagId}".`);
  }
  return enabled;
}
async function fetchAllFeatureFlags() {
  const endpoint = "/api/feature-flipping";
  try {
    return await useUniversalFetch(endpoint);
  } catch {
  }
  return [];
}
export function useFeatureFlag() {
  return {
    isFeatureEnabledForHost,
    isFeatureEnabled,
    fetchFeatureFlags,
    fetchAllFeatureFlags,
    switchStateFeatureFlag
  };
}
